interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  danger?: boolean;
}

export default function ConfirmDialog({
  title, message, confirmLabel, onCancel, onConfirm, danger,
}: ConfirmDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-background-50 rounded-xl shadow-lg max-w-sm w-full p-6 space-y-4">
        <div className="flex items-start gap-3">
          <span className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${
            danger ? 'bg-red-100' : 'bg-amber-100'
          }`}>
            <i className={`${danger ? 'ri-error-warning-line text-red-600' : 'ri-question-line text-amber-600'}`}></i>
          </span>
          <div>
            <h3 className="text-sm font-semibold text-foreground-900">{title}</h3>
            <p className="text-sm text-foreground-600 mt-1">{message}</p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 pt-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg bg-background-100 hover:bg-background-200 text-foreground-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            キャンセル
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              danger
                ? 'bg-red-500 hover:bg-red-600 text-white'
                : 'bg-primary-500 hover:bg-primary-600 text-background-50'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}